import {httpsFunctions} from "../../../../api/Api";


const parseResponse = (result) => {
    return {
        exists: result.data?.data?.exists,
        course: result.data?.data?.course,
        error: result.data?.error
    }
};

export const checkMemberByEmail = async (email) => {

    return httpsFunctions.post('/checkMember', {
        email
    })
        .then(parseResponse);
}

export const checkMemberById = async (id) => {
    return httpsFunctions.post('/checkMember', {id})
        .then(parseResponse);
}
